import resumeEditor from './pc/editor.vue'
import '@/assets/scss/adaptWrapper.scss'
import { deviceType } from '@/utils/common'
import mobileResumeEditor from './mobile/editor.vue'
import RootLayout from '../layout/rootLayout.vue'
import BlankLayout from '../layout/blankLayout.vue'

const basePath = '/recruiting/personal'

export default {
  name: 'personalResume',
  path: `${basePath}/resume`,
  component: deviceType.isPc ? RootLayout : BlankLayout,
  meta: {
    isRootLayout: true,
    mobileAllFlexible: true,
    mobileHomeMenu: {
      redirectPath: '/mobile-web-mini-resume/',
      iconClass: 'iconresume',
      nameI18nKey: 'personal.resume.homeMenu.name',
      descI18nKey: 'personal.resume.homeMenu.desc'
    },
    rootLayout: {
      hiddenBackgroundImage: true,
      hiddenTabList: true,
      flexMode: true,
      hiddenLeftPadding: true
    },
    menuI18nKey: 'personal.resume.tabTitle.index'
  },
  children: [
    {
      name: 'personalResumeAdd',
      path: `${basePath}/resume/add`,
      component: deviceType.isPc ? resumeEditor : mobileResumeEditor,
      meta: {
        isAddMode: true,
        isEditMode: false,
        isMiniResume: false,
        isBasicResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeAdd',
        personalLayout: {
          blankPage: true
        },
        rootLayout: {
          hiddenLeftPadding: true
        }
      }
    },
    {
      name: 'personalResumeEdit',
      path: `${basePath}/resume/edit`,
      component: deviceType.isPc ? resumeEditor : mobileResumeEditor,
      meta: {
        isEditMode: true,
        isMiniResume: false,
        isBasicResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        },
        rootLayout: {
          hiddenLeftPadding: true
        }
      }
    },
    {
      name: 'personalMiniResumeAdd',
      path: `${basePath}/mini-resume/add`,
      component: deviceType.isPc ? resumeEditor : mobileResumeEditor,
      meta: {
        isAddMode: true,
        isEditMode: false,
        isMiniResume: true,
        isBasicResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        },
        rootLayout: {
          hiddenLeftPadding: true
        }
      }
    },
    {
      name: 'personalMiniResumeEdit',
      path: `${basePath}/mini-resume/edit`,
      component: deviceType.isPc ? resumeEditor : mobileResumeEditor,
      meta: {
        isEditMode: true,
        isMiniResume: true,
        isBasicResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        },
        rootLayout: {
          hiddenLeftPadding: true
        }
      }
    },
    {
      name: 'personalBasicResumeEdit',
      path: `${basePath}/basic-resume/edit`,
      component: deviceType.isPc ? resumeEditor : mobileResumeEditor,
      meta: {
        isEditMode: true,
        isMiniResume: false,
        isBasicResume: true,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        },
        rootLayout: {
          hiddenLeftPadding: true
        }
      }
    }

  ]
}
